import api from '@/api/reports';

const WAIT_KEY = 'k12SchoolEnrollmentReport.fetching';
const DOWNLOAD_WAIT_KEY = 'k12SchoolEnrollmentReport.downloading';

const actions = {
  FETCH_REPORT: async ({ commit, dispatch, state, rootGetters }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      pageSize,
      currentPage,
      ordering,
      filters: { query: search },
    } = state;
    const offset = currentPage * pageSize;

    const params = {
      organization_id: organizationId,
      limit: pageSize,
      offset,
      ordering,
      search,
      start_date: startDate,
      end_date: endDate,
    };

    dispatch('wait/start', WAIT_KEY, { root: true });

    try {
      const { count, results: report } = await api.fetchK12SchoolEnrollmentReport(params);

      commit('SET_REPORT', report);
      commit('SET_COUNT', count);

      return report;
    } finally {
      dispatch('wait/end', WAIT_KEY, { root: true });
    }
  },

  DOWNLOAD_REPORT: async ({ dispatch, state, rootGetters }, { formatType }) => {
    const { organizationId } = rootGetters;
    const {
      dateRange: { start: startDate, end: endDate },
      ordering,
      filters: { query: search },
    } = state;
    const fields = state.columns.filter(x => x.showColumn).map(x => x.source_field);

    dispatch('wait/start', DOWNLOAD_WAIT_KEY, { root: true });

    try {
      await api.fetchK12SchoolEnrollmentReport({
        organization_id: organizationId,
        ordering,
        search,
        start_date: startDate,
        end_date: endDate,
        format: formatType,
        include: fields,
      });
    } finally {
      dispatch('wait/end', DOWNLOAD_WAIT_KEY, { root: true });
    }
  },

  CHANGE_PAGE_SIZE: ({ commit, dispatch }, pageSize) => {
    commit('SET_PAGE_SIZE', pageSize);
    dispatch('FETCH_REPORT');
  },

  CHANGE_CURRENT_PAGE: ({ commit, dispatch }, { currentPage }) => {
    commit('SET_CURRENT_PAGE', currentPage);
    dispatch('FETCH_REPORT');
  },

  CHANGE_ORDERING: ({ commit, dispatch, state }, { ordering }) => {
    if (ordering === state.ordering) {
      return;
    }

    commit('SET_ORDERING', ordering);
    dispatch('FETCH_REPORT');
  },

  DATE_RANGE_UPDATE: ({ commit, dispatch }, dateRange) => {
    commit('SET_DATE_RANGE', dateRange);
    commit('SET_CURRENT_PAGE', 0);
    dispatch('FETCH_REPORT');
  },
};

export default actions;
